import React from 'react';
var context = React.createContext({});
var Consumer = context.Consumer,
  Provider = context.Provider;
export { Consumer, Provider };